const logoBaseURL = "https://www.mweb.co.za/media/images/providers"
export const providerInfo = [
    {
      code: 'webconnect',
      name: 'Web Connect',
      url: `${logoBaseURL}/provider-web-connect.png`
    },
    {
      code: 'zoomfibre',
      name: 'ZoomFibre',
      url: `${logoBaseURL}/provider-zoomfibre.png`
    },
    {
      code: 'ttconnnect',
      name: 'TT Connect',
      url: `${logoBaseURL}/provider-tt-connect.png`
    },
    {
      code: 'thinkspeed',
      name: 'Thinkspeed',
      url: `${logoBaseURL}/provider-thinkspeed.png`
    },
    {
      code: 'clearaccess',
      name: 'ClearAccess',
      url: `${logoBaseURL}/provider-clearaccess.png`
    },
    {
      code: 'evotel',
      name: 'Evotel',
      url: `${logoBaseURL}/provider-evotel.png`
    },
    {
      code: 'octotel',
      name: 'Octotel',
      url: `${logoBaseURL}/provider-octotel.png`
    },
    {
      code: 'vumatel',
      name: 'Vumatel',
      url: `${logoBaseURL}/provider-vuma.png`
    },
    {
      code: 'openserve',
      name: 'OpenServe',
      url: `${logoBaseURL}/provider-openserve.png`
    },
    {
      code: 'frogfoot',
      name: 'Frogfoot',
      url: `${logoBaseURL}/provider-frogfoot.png`
    },
    {
      code: 'frogfootair',
      name: 'Frogfoot Air',
      url: `${logoBaseURL}/provider-frogfootair.png`
    },
    {
      code: 'mfn',
      name: 'MFN',
      url: `${logoBaseURL}/provider-metrofibre.png`
    },
    {
      code: 'vodacom',
      name: 'Vodacom',
      url: `${logoBaseURL}/provider-vodacom.png`
    },
    {
      code: 'linkafrica',
      name: 'Link Africa',
      url: `${logoBaseURL}/provider-linkafrica.png`
    },
    {
      code: 'linklayer',
      name: 'Link Layer',
      url: `${logoBaseURL}/provider-link-layer.png`
    },
    {
      code: 'lightstruck',
      name: 'Lightstruck',
      url: `${logoBaseURL}/provider-lightstruck.png`
    },
    {
      code: 'mitchells',
      name: 'Mitchells Fibre',
      url: `${logoBaseURL}/provider-mitchells.png`
    },
    {
      code: 'vumareach',
      name: 'Vuma Reach',
      url: `${logoBaseURL}/provider-vuma.png`
    }
  ]